import React from 'react'
import './index.css';
import { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Project } from './Project';
import scripter from '../../assets/scripter.png';
import dilli from '../../assets/dilli_darbar_times.png';
import cpg from '../../assets/conditional_password.png';
import sv from '../../assets/sorting_visualiser.png';
import ddy from '../../assets/daddy_jokes.png';
import pk from '../../assets/pokedex.png';
import srms from '../../assets/srms.png';
import bolly from '../../assets/abir82_bollywood_recommendation.png';

export const Portfolio = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const controls = useAnimation();
  useEffect(() => {
    controls.start({ opacity: 1, x: 0 });
  }, [controls]);
  const isDesktop = screenWidth >= 600;
  return (
    <motion.div className='Portfolio'
      initial={{ opacity: 0, x: -20 }}
      animate={controls}
      transition={{ duration: 1 }}
    >
      <div className="Header">
        Projects
      </div>

      <div className="ProjectsSection">

        <Project img={scripter} type="Product" title="Scripter 2" date="March, 2023" details="Scripter is a personalised notes app capable of holding personal data and it doesn't require any kinds of installment." link="https://scripter2.netlify.app/" techstack={["mongo db","express","react","node"]} />

        <Project img={dilli} type="Hackathon Project" title="Diilli Darbar Times" date="August, 2022" details="Diilli Darbar Times is a Hackathon Project where the problem statement was to build an e-newspaper." link="https://trojan-riders.github.io/diilli-darbar-times/" techstack={["HTML","CSS","JS"]} />
        
        <Project img={cpg} type="Node Package" title="Conditional Password Generator" date="August, 2022" details="Conditional Password Generator generates password in a random order with customized number of characters, numbers and symbols, making it impossible for hackers to guess." link="https://www.npmjs.com/package/conditional-password-generator" techstack={["Node JS"]} />

        <Project img={sv} type="Standalone Project" title="Sorting Visualiser" date="July, 2022" details="This is a web project which visualizes the working of various Sorting Algorithms." link="https://abirbhattacharya82.github.io/Sorting-Visualizer/" techstack={["HTML","CSS","JS"]} />

        <Project img={ddy} type="Node Package" title="Daddy-Jokes" date="September, 2022" details="A dad joke is a short joke, typically a pun, presented as a one-liner or a question and answer, but not a narrative. This package generates random Dad jokes for you." link="https://www.npmjs.com/package/daddy-jokes" techstack={["Node JS"]} />

        <Project img={pk} type="Standalone Project" title="Pokedex" date="July, 2022" details="The Pokédex is an electronic device created and designed to catalog and provide information regarding the various species of Pokémon. This is a replica of Pokedex." link="https://abirbhattacharya82.github.io/Pokedex/" techstack={["HTML","CSS","JS"]} />

        <Project img={srms} type="Standalone Project" title="Student Result Management System" date="December, 2021" details="This is a CLI based software where the Software is capable of maintaining and generating Student's Result at the end of a semester after the teacher's have provided the respective marks." link="https://github.com/abirbhattacharya82/Student_Result_Management_System" techstack={["Java","MySQL","JDBC"]} />

        <Project img={bolly} type="Rapid API" title="Abir82 Bollywood Recommendation" date="October, 2022" details="This API recommends a list of Bollywood movies from 2000 to 2020 based on the genre and year selected by the user." link="https://rapidapi.com/abirbhattacharya82/api/abir82-bollywood-recommendations/" techstack={["Express","Node"]} />

      </div>

      

    </motion.div>
  )
}
